import * as info from '../../package.json';
// Environment data
export const packageJson = {
  version: info.version,
  buildDate: new Date().toISOString(),
};
